import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLanguage } from "@/hooks/useLanguage";
import { getLocalizedPath } from "@/utils/routes";
import { PublicSiteFooter } from "@appcaire/ui";
import { getFooterConfig } from "./navConfig";

/**
 * The website's adapter over the shared public footer: router links, the
 * website's locale files and its cookie control.
 */
export const Footer = () => {
  const { language } = useLanguage();
  /** Bind to URL language so footer strings match /en vs Swedish paths before i18n.language catches up */
  const { t: tFooter } = useTranslation("footer", { lng: language });

  const link = (key: string) => getLocalizedPath(key, language);
  const footerConfig = getFooterConfig(tFooter, language);

  return (
    <PublicSiteFooter
      locale={language === "en" ? "en" : "sv"}
      description={tFooter(
        "company_description",
        language === "sv"
          ? "CAIRE skapar teknik med hjärta för hemtjänsten."
          : "CAIRE builds technology with a human touch for home care.",
      )}
      rights={tFooter("rights", "All rights reserved.")}
      sections={[
        { id: "product", ...footerConfig.product },
        { id: "solutions", ...footerConfig.solutions },
        { id: "trust", ...footerConfig.trust },
        { id: "resources", ...footerConfig.resources },
        { id: "company", ...footerConfig.company },
      ]}
      contact={{
        label: tFooter("contact_us", "Contact us"),
        href: link("contact"),
      }}
      legalLinks={[
        {
          label: tFooter("privacy_policy", "Privacy"),
          href: link("legal.privacy"),
        },
        { label: tFooter("terms", "Terms"), href: link("legal.terms") },
      ]}
      legalExtra={
        <button
          id="cookie-btn"
          className="text-[#b5bfca] transition-colors hover:text-white"
        >
          {tFooter("cookies", "Cookies")}
        </button>
      }
      renderLink={({ href, className, children }) => (
        <Link to={href} className={className}>
          {children}
        </Link>
      )}
    />
  );
};
